const reveal2FaSecret = document.getElementById('reveal-2fa-secret')

if (reveal2FaSecret) {
    reveal2FaSecret.addEventListener('click', () => {
        document.getElementById('2fa-secret').classList.remove('hidden')
    })
}
